import { render, staticRenderFns } from "./SubscriptionGiftCouponDetail.vue?vue&type=template&id=1694723b&scoped=true&lang=pug&"
import script from "./SubscriptionGiftCouponDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionGiftCouponDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubscriptionGiftCouponDetail.vue?vue&type=style&index=0&id=1694723b&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694723b",
  null
  
)

export default component.exports